(function () {
  if (window.__splitContentTabsScriptBound) return;
  window.__splitContentTabsScriptBound = true;

  class SplitContentTabsSection {
    constructor(section) {
      this.section = section;
      this.triggers = Array.from(section.querySelectorAll("[data-tab-trigger]"));
      this.panels = Array.from(section.querySelectorAll("[data-tab-panel]"));
      this.boundHandleTriggerClick = this.handleTriggerClick.bind(this);
      this.boundHandleTriggerKeydown = this.handleTriggerKeydown.bind(this);
      this.init();
    }

    init() {
      if (!this.triggers.length) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.boundHandleTriggerClick);
        trigger.addEventListener("keydown", this.boundHandleTriggerKeydown);
      });

      const activeTrigger =
        this.section.querySelector("[data-tab-trigger][data-active]") || this.triggers[0];

      if (activeTrigger) {
        this.activateTab(activeTrigger.dataset.tabTrigger);
      }
    }

    activateTab(tabId) {
      let activeTrigger = null;

      this.triggers.forEach((trigger) => {
        const isActive = trigger.dataset.tabTrigger === tabId;

        if (isActive) {
          activeTrigger = trigger;
          trigger.setAttribute("data-active", "");
          trigger.setAttribute("aria-selected", "true");
          trigger.setAttribute("tabindex", "0");
        } else {
          trigger.removeAttribute("data-active");
          trigger.setAttribute("aria-selected", "false");
          trigger.setAttribute("tabindex", "-1");
        }
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tabId;
      });

      return activeTrigger;
    }

    scrollActiveTriggerIntoView(trigger) {
      if (!trigger || !trigger.closest(".split-content-tabs__tablist")) return;

      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      trigger.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }

    handleTriggerClick(event) {
      const trigger = event.currentTarget;
      const activeTrigger = this.activateTab(trigger.dataset.tabTrigger);
      this.scrollActiveTriggerIntoView(activeTrigger);
    }

    handleTriggerKeydown(event) {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;

      event.preventDefault();

      const currentIndex = this.triggers.indexOf(event.currentTarget);
      const nextIndex =
        event.key === "ArrowRight"
          ? (currentIndex + 1) % this.triggers.length
          : (currentIndex - 1 + this.triggers.length) % this.triggers.length;
      const nextTrigger = this.triggers[nextIndex];

      if (!nextTrigger) return;

      this.activateTab(nextTrigger.dataset.tabTrigger);
      nextTrigger.focus();
    }

    selectBlock(blockId) {
      if (!blockId) return;

      const activeTrigger = this.activateTab(blockId);
      this.scrollActiveTriggerIntoView(activeTrigger);
    }

    destroy() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener("click", this.boundHandleTriggerClick);
        trigger.removeEventListener("keydown", this.boundHandleTriggerKeydown);
      });

      this.section.splitContentTabsInstance = null;
    }
  }

  const initSplitContentTabs = (root = document) => {
    const sections = [];

    if (root instanceof Element && root.matches(".split-content-tabs__tabs[data-section-id]")) {
      sections.push(root);
    }

    sections.push(...root.querySelectorAll(".split-content-tabs__tabs[data-section-id]"));

    sections.forEach((section) => {
      if (section.splitContentTabsInstance) return;
      section.splitContentTabsInstance = new SplitContentTabsSection(section);
    });
  };

  initSplitContentTabs();

  document.addEventListener("shopify:section:load", function (event) {
    initSplitContentTabs(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const sectionTabs = event.target.querySelector(".split-content-tabs__tabs[data-section-id]");
    if (sectionTabs && sectionTabs.splitContentTabsInstance) {
      sectionTabs.splitContentTabsInstance.destroy();
    }
  });

  document.addEventListener("shopify:block:select", function (event) {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId) return;

    const sectionTabs = event.target.querySelector(".split-content-tabs__tabs[data-section-id]");
    if (!sectionTabs || !sectionTabs.splitContentTabsInstance) return;

    sectionTabs.splitContentTabsInstance.selectBlock(blockId);
  });
})();
